// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_pk-5";
export var filledCircle = "_pk-4";
export var historyEntry = "_pk-3";
export var messageSideLeft = "_pk-1";
export var messageSideRight = "_pk-2";
export var orderTrackingCarouselWrapper = "_pk-6";
export var orderTrackingInfoContainer = "_pk-0";